import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { Hooks } from "@grandvisionhq/stores-v2";
import { useLoggedInCheckout } from "../../../../../../../../../context/LoginExpressCheckout/context/context.js";
import { StoreSummary } from "../../../../../../../../../../modules/ServiceStore/components/modules/ServiceStore/components/StoreSummary.js";
const ServiceStoreSummaryContainer = ({
  isOrderDetailsValid,
  isServiceStoreValid,
  title,
  onEditHandler
}) => {
  const { getLabel } = useIntl();
  const { cart } = Context.useCart();
  const { shippingState, setShippingState } = useLoggedInCheckout();
  const [getStoreById, storeById] = Hooks.useStoreById();
  const storeSummary = React.useMemo(() => {
    if (storeById.error || !storeById.data) return { name: "", streetName: "", streetNumber: "" };
    const { name, streetName, streetNumber } = storeById.data;
    return {
      name,
      streetName,
      streetNumber
    };
  }, [storeById?.data, storeById.error]);
  const loadStoreDetails = React.useCallback(
    async (globalStoreId) => {
      await getStoreById({ variables: { globalStoreId } });
    },
    [getStoreById]
  );
  const updateServiceStoreState = React.useCallback(() => {
    storeById.data?.globalStoreId && setShippingState({
      ...shippingState,
      serviceStore: {
        ...storeById.data
      }
    });
  }, [setShippingState, shippingState, storeById.data]);
  React.useEffect(() => {
    if (cart?.serviceStore?.globalStoreId) {
      loadStoreDetails(cart.serviceStore.globalStoreId);
    }
  }, [cart?.serviceStore?.globalStoreId]);
  React.useEffect(() => {
    if (storeById?.data?.globalStoreId) {
      updateServiceStoreState();
    }
  }, [storeById?.data?.globalStoreId]);
  return /* @__PURE__ */ React.createElement(
    StoreSummary,
    {
      ...storeSummary,
      actions: {
        onEdit: onEditHandler
      },
      title,
      errorNotification: !isServiceStoreValid ? /* @__PURE__ */ React.createElement(
        Alert,
        {
          className: "alert-m-default ",
          role: isOrderDetailsValid ? "status" : "alert",
          variant: isOrderDetailsValid ? "info" : "error",
          title: getLabel("checkout.serviceStore.incomplete.title")
        },
        getLabel("checkout.information.incomplete.message")
      ) : null
    }
  );
};
export {
  ServiceStoreSummaryContainer
};
//# sourceMappingURL=ServiceStoreSummaryContainer.js.map
